import React from 'react';
import { Navbar, Container, NavbarBrand, Row, Col, Nav, NavItem, Button } from 'reactstrap';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import AssessorLogo from '../../assets/images/AssessorLogo.png';

const NavbarComponent = ({ language, languagesList, changeLanguages, resetIndex, showLogout }) => {
    const channel = new BroadcastChannel('my-channel');
    const logout = () => {
        channel.postMessage({ action: 'logout' });
    };
    return (
        // eslint-disable-next-line no-inline-styles/no-inline-styles
        <Navbar fixed="top" light expand="md" className="mb-5 navbar-bg-white">
            <Container fluid>
                <Row className="w-100 align-items-center">
                    <Col className="d-flex justify-content-between align-items-center">
                        <NavbarBrand className="cursor-pointer">
                            <img onClick={resetIndex} src={AssessorLogo} alt="Logo" className="img-fluid custom-logo" />
                        </NavbarBrand>
                    </Col>
                    {/* {languagesList?.length > 0 && ( */}
                    <Col className="d-flex justify-content-end">
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <LanguageSelector
                                    currentLanguage={language}
                                    languagesList={languagesList}
                                    changeLanguages={changeLanguages}
                                />
                            </NavItem>
                        </Nav>
                        {showLogout && (
                            <Button color="success" onClick={logout} size="md" className="ms-5">
                                Logout
                            </Button>
                        )}
                    </Col>
                    {/* )} */}
                </Row>
            </Container>
        </Navbar>
    );
};

export default NavbarComponent;

// style={{ backgroundColor: '#ffffff' }}
